import { GET_OPERADORES_MONGO } from './mutation-types'

export default {
  [GET_OPERADORES_MONGO]: (state, operadores) => {
    state.operadores = operadores
  },
}
